import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import app from './modules/app'
import route from './modules/route'
import search from './modules/search'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    app,
    route,
    search
  },
  getters
})

export default store
